export default __webpack_public_path__ + "static/media/pichome.7f9b4f00.jpg";